export enum DefaultBooleanChoiceEnum {
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}
